(() => {window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('body').classList.contains('embed')) {
            return
        }

        if (window.location.search.includes('trackingNumber')) {
            return
        }

        document.querySelector('body').classList.add('embed--hasnonumber')
    })
}) ()
